












import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'
import TabItem from './TabItem.vue'
@Component({
  components:{
    TabItem
  }
})
export default class ZwlTabs extends Vue {
  @State tabs
  @Prop({ default: true }) hasQuery!: boolean
}
